import * as ko from "knockout";
import * as $ from "jquery";
import Bao from "./../services/bao-service";
// bao migrate - module not found: import "vendor/jquery_transit";
import "jquery.transit";
ko.bindingHandlers.fadeVisible = {
    init: function (element, valueAccessor) {
        var value = valueAccessor();
        $(element).hide();
        $(element).css({
            opacity: 0
        });
    },
    update: function (element, valueAccessor) {
        var value = valueAccessor();
        if (ko.unwrap(value)) {
            $(element).show();
            $(element).transition({
                opacity: 1
            }, 500);
        }
        else {
            $(element).transition({
                opacity: 0
            }, 500, function () {
                if (ko.unwrap(valueAccessor()) == false) {
                    $(element).hide();
                }
            });
        }
    }
};